<form [formGroup]="fileFilters">
  <div class="file-attachment-container">
    <label>Maximum age</label>
    <mat-select
      class="file-max-age"
      formControlName="fileMaxAgeDays"
      placeholder="Maximum Age"
      matTooltip="Maximum age of attachment file"
      matTooltipShowDelay="500"
      >
      @for (fileAge of fileAgeOptionsNonStatic; track fileAge) {
        <mat-option [value]="fileAge.days">{{ fileAge.label }}</mat-option>
      }
    </mat-select>
  </div>
</form>
